"use client"

import { Card, CardContent, CardHeader } from "@/components/ui/card"

export function BlogCardSkeleton() {
  return (
    <Card className="bg-white/95 border border-gray-200 shadow-lg overflow-hidden animate-pulse h-full flex flex-col">
      {/* Image skeleton */}
      <div className="aspect-video bg-linear-to-br from-gray-200 to-gray-300" />
      
      <CardHeader className="p-5 md:p-6 pb-4">
        {/* Badges skeleton */}
        <div className="flex items-center gap-2 mb-3">
          <div className="h-6 bg-gray-200 rounded-md w-20" />
          <div className="h-6 bg-gray-200 rounded-md w-16" />
        </div>
        
        {/* Title skeleton */}
        <div className="space-y-2 mb-3">
          <div className="h-6 bg-gray-200 rounded w-3/4" />
          <div className="h-6 bg-gray-200 rounded w-1/2" />
        </div>
        
        {/* Metadata skeleton */}
        <div className="flex items-center gap-2">
          <div className="h-4 bg-gray-200 rounded w-24" />
          <div className="h-4 bg-gray-200 rounded w-20" />
        </div>
      </CardHeader>
      
      <CardContent className="px-5 md:px-6 pb-5 flex flex-col grow">
        {/* Excerpt skeleton */}
        <div className="space-y-2 mb-5 grow">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-5/6" />
          <div className="h-4 bg-gray-200 rounded w-4/6" />
        </div>
        
        {/* Button skeleton */}
        <div className="flex justify-end">
          <div className="h-10 bg-gray-200 rounded-full w-32" />
        </div>
      </CardContent>
    </Card>
  )
}







